"use strict";
/**************************************************************************************************
 *
 *      @file ./extend-kotlin-hash-map.ts
 *
 *      Polyfill Kotlin HashMap objects to contain keys available on JS map
 *      objects, thus allowing Kotlin HashMap objects to operate
 *      near-seamlessly as JS maps.
 *
 *      Polyfill is immediately applied globally on importing this file.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kotlin_1 = __importDefault(require("kotlin"));
var keys = Object.keys, assign = Object.assign;
/********************************************* CONFIG *********************************************/
/**
 * Names of keys containing the Kotlin hashmap put & get methods
 */
var putKey = "put_xwzc9p$";
var getKey = "get_11rb$";
var newGetKeyIWantToAdd = "get_za3lpa$";
/***************************************** LOCAL HELPERS ******************************************/
/**
 * Find the name of the 'key' key in an entry on a kotlin hashmap
 *
 * @param {KHashMapEntry} Kotlin hashmap entry (kotlin.collections.HashMap.entries.toArray()[0])
 * @return {string} Name of the 'key' getter property
 */
var getKHashMapEntryKeyGetterName = function (hMapEntry) {
    return hMapEntry.key_5xhq3d$_0 ||
        hMapEntry.key_af2vu2$_0 ||
        keys(hMapEntry).find(function (hMapEntryKey) { return !!hMapEntryKey.match(/key_[a-z0-9]/); });
};
/**
 * Given a root key name, retrieve Kotlin's corresponding hash-appended variant method/key name
 * on the given object.
 */
var getKotlinKeyFromBaseKey = function (objWHashedKeyName, baseKeyName) {
    var keyNameRegex = new RegExp(baseKeyName + "_[a-z0-9]+$_?[0-9]?");
    return keys(objWHashedKeyName).find(function (hMapEntryKey) { return !!hMapEntryKey.match(keyNameRegex); });
};
/******************************* KOTLIN HASHMAP CONVENIENCE METHODS *******************************/
kotlin_1.default.kotlin.collections.HashMap.prototype.put =
    kotlin_1.default.kotlin.collections.HashMap.prototype[putKey];
kotlin_1.default.kotlin.collections.HashMap.prototype.get =
    kotlin_1.default.kotlin.collections.HashMap.prototype[getKey];
kotlin_1.default.kotlin.collections.HashMap.prototype.getKeys = function getKeys() {
    return this.keys.toArray();
};
kotlin_1.default.kotlin.collections.HashMap.prototype.getValues = function getValues() {
    return this.values.toArray();
};
kotlin_1.default.kotlin.collections.HashMap.prototype.getEntries = function getEntries() {
    return this.entries
        .toArray()
        .map(function (entry) { return [getKHashMapEntryKeyGetterName(entry), entry._value_0]; });
};
kotlin_1.default.kotlin.collections.HashMap.prototype.getObject = function getObject() {
    return this.entries
        .toArray()
        .reduce(function (acc, entry) {
        var _a;
        return assign(acc, (_a = {}, _a[getKHashMapEntryKeyGetterName(entry)] = entry._value_0, _a));
    }, {});
};
exports.KotlinHashMap = kotlin_1.default.kotlin.collections.HashMap;
//# sourceMappingURL=extend-kotlin-hash-map.js.map